import {environment} from './environment';

export enum EnvName {
    Dev = 'dev',
    Prod = 'prod',
    Stage = 'stage',
}

const defaultEnv = environment.production ? EnvName.Prod : EnvName.Dev;

export const getEnvName = (): EnvName => {
    let meta = <HTMLMetaElement>document.getElementById('environmentName');
    if (meta && [EnvName.Prod, EnvName.Stage].includes(<EnvName>meta.content)) {
        return <EnvName>meta.content;
    }
    return defaultEnv;
};
